import { useState } from 'react';

//import { firestoreMethods } from '../firebase/firestoreMethods';
//import { utilMethods } from '../utils/utilMethods';

import { Link } from "react-router-dom";


function TestAddress() {
  const [mode, setMode] = useState("NEW");

   const initFormState = 
    {
      lineOne: '',
      lineTwo: '',
      city: '',
      state: '', 
      zip: '',
    };

  const fields = Object.keys(initFormState);
  const [inputs, setInputs] = useState(initFormState);

  const handleChange = (e) => {
    const {name, value} = e.target
    setInputs(prev => ({...prev, [name]: value}))
  }

  const handleSubmit = async () => {
    setMode("SAVED");
    setInputs(initFormState);
  }

  return (
    <>
      <div className='outer-box'>
        <div className='title'>
          Test Address
        </div>
        <div className='form-button-group'>
          <Link 
            to="/test/login" 
            className='form-button primary'
          >login
          </Link> 
        </div>
        {(mode === 'NEW') ?
        <>
          {fields.map((field) => 
            {
              return <div className="form-field" key={field}>
                <div className='form-label'>{field}</div>
                <input 
                  name={field}
                  type="text" 
                  onChange={(handleChange)} 
                  value={inputs[field] || ''}
                  className='form-input'
                />  
              </div>
            })

          }
    
          <div className='form-button-group'>
            <button className='form-button primary' type='submit' onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </> :
        <>
          <div>You've updated your form</div>
          <div className='form-button primary' onClick={() => setMode('NEW')}>
            Make New
          </div>
        </>
      }



      </div>
    </>
  );
}

export default TestAddress;
